// extracted by mini-css-extract-plugin
export default {"root":"Uploader_root__bqPTL","img":"Uploader_img__jTjOS","upload":"Uploader_upload__5K8EV","btnContainer":"Uploader_btnContainer__zeTf5","info":"Uploader_info__NlMaA"};